import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type { ISalesInvoicesReturnItemsResponse } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ISalesInvoicesReturnItemsResponse>>,
  IPathBaseParam,
  IPaginationParams
>("stores.salesInvoices.returns.items");

const getApis = createGetApi<
  IApiResponse<ISalesInvoicesReturnItemsResponse>,
  IPathByIdParam,
  object
>("stores.salesInvoices.returns.items");

export const items = {
  ...getAllApis,
  ...getApis,
};
